export interface Uga  {
    codComune: string;
    code: string;
    description: string;
    name: string;
    wktGshape: string;    
}
export interface Card {
    icon: string;
    label: string;
    value: string;
    unit?: string;
}

export interface SummaryProduction {
    estimetedCurrentYearQli: number;
    effectiveCurrentYearQli: number;
    previousYearQli: number;
    averageRecentYearsQli: number;
    estimetedCurrentYearKg: number;
    effectiveCurrentYearKg: number;
    previousYearKg: number;
    averageRecentYearsKg: number;
}

export interface Summary {
    numberOfEvaluations: number;
    vineyardMonitored: number;
    avgWeightBunch: number;
    numberOfBunchesForPlant: number;
    productionPerPlant: SummaryProduction;
    productionPerHa: SummaryProduction;
    totalProduction: SummaryProduction;
}

export interface ScsSummary {
    numberOfFarms: number;
    area: number;
    numberVarietyUsed: number;
    avgProductionPerPlant: SummaryProduction;
    avgProductionPerHa: SummaryProduction;
    avgProductionPerFarm: SummaryProduction;
    totalProductionForScs: SummaryProduction;
}

export interface FibeoItem {
    id: number;
    name: string;
    description: string;
}

export interface TodoItem {
    completed: boolean;
    id: number;
    title: string;
    userId: number;
}

export interface Variety {
    area_ha: number;
    campaign: number;
    crop_code: string;
    rotation: number;
    scs_subject_id: number;
    seed_variety_id: number | null;
    item_id: number | null;
    subject_id: number;
    subject_name: string;
    variety: string;
}

export interface DashboardVariety {
    agm_group_code: string;
    area_ha: number;
    campaign: number;
    crop_code: string;
    rotation: number;
    scs_subject_id: number;
    seed_variety_id: number;
    item_id: number;
    subject_id: number;
    subject_name: string;
    variety: string;
}

export interface VarietyBase {
    id: number | null;
    code: string;
    description: string;
}

export interface VegetativeCycle {
    cycle_id: number;
    cycle_number: number;
    end_date: number;
    precocity_description: string;
    seed_code: string;
    seed_id: number;
    seed_name: string;
    seed_variety_id: number;
    item_id: number;
    start_date: number;
}

export function fromDashboardVarietyToVarietyBase(e: DashboardVariety): VarietyBase {
    return {
        id: e.item_id,
        code: e.crop_code,
        description: e.variety,
    }
}

export function fromVarietyToVarietyBase(e: Variety): VarietyBase {
    return {
        id: e.item_id,
        code: e.crop_code,
        description: e.variety,
    }
}

export function fromVegetativeCycleToVarietyBase(e: VegetativeCycle): VarietyBase {
    return {
        id: e.item_id,
        code: e.seed_code,
        description: e.seed_name,
    }
}